// extracted by mini-css-extract-plugin
export default {"footerBanner":"SidebarFooter_footerBanner__Dy+F-"};